import {createAction, props} from "@ngrx/store";
import {IRolesDto} from "../../../../../global/permissions/store/permission.reducer";
import {UserListDto, UserListItemDto} from "../dto/user-list.dto";
import {UsersListingFeatureKey} from "./users-listing.config";


const scope = `[${UsersListingFeatureKey}]`;

export const resetState = createAction(`${scope} Reset state`);
export const fetchUsers = createAction(`${scope} Fetch Users`);
export const fetchUsersSucceeded = createAction(`${scope} Fetch Users Succeeded`, (usersList:UserListDto )=> ({usersList}));
export const fetchUsersFailed = createAction(`${scope} Fetch Users Failed`, (error: string)=> ({error}));
export const changePage = createAction(`${scope} Change Page`, (pageNumber: number)=>({pageNumber}));
export const searchChange = createAction(`${scope} Search value changed`, (searchValue: string)=> ({searchValue}) );
export const selectedUser = createAction(`${scope} User Selected`, (userId:number)=>({userId}));

export const addWorkspace = createAction(`${scope} Add workspace`, (userId: number, workspaceId:number, name: string)=>({userId,workspaceId, name}));

export const removeWorkspace = createAction(`${scope} Remove workspace`, (userId:number, workspaceId:number)=>({userId, workspaceId}));

export const updateUser = createAction(`${scope} Update user`, (userData: Partial<UserListItemDto>)=>({userData}));

export const deleteUser = createAction(`${scope} Delete user`, (userId:number)=> ({userId}));

export const invitePersonSucceeded = createAction(`${scope} Invite person succeeded`);

export const updateUserRoles = createAction(`${scope} Update User Roles`, props<{userId:number, roles: IRolesDto[]}>());

export const sideBsrOpened = createAction(`${scope} User Side Bar Opened`);

export const sideBsrClosed = createAction(`${scope} User Side Bar Closed`);